/* eslint-disable react/prop-types */
import { createContext, useContext, useState } from 'react'

const ThemeContext = createContext()
const ThemeUpdateContext = createContext()

export function useTheme() {
  return useContext(ThemeContext)
}

export function useThemeUpdate() {
  return useContext(ThemeUpdateContext)
}

export function ThemeProvider({ children }) {
  const [darkTheme, setdarkTheme] = useState(false)

  function toggleTheme() {
    setdarkTheme(!darkTheme)
  }
  return (
    <ThemeContext.Provider value={darkTheme}>
      <ThemeUpdateContext.Provider value={toggleTheme}>
        {children}
      </ThemeUpdateContext.Provider>
    </ThemeContext.Provider>
  )
}
